export const cellText = {
  fontSize: 12,
  fontFamily: "monospace",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap" as const,
  display: "block",
};

export const disabledSx = {
  "& .MuiOutlinedInput-root.Mui-disabled": { backgroundColor: "#f0f0f0" },
  "& .MuiOutlinedInput-input.Mui-disabled": { WebkitTextFillColor: "#333" },
};

export const mobileCardSx = {
  border: "1px solid #e0e0e0",
  borderRadius: 2,
  p: 1.5,
  bgcolor: "#fff",
};

export const checkboxSx = (color: string) => ({
  p: "2px",
  color: "#B0BEC5",
  "&.Mui-checked": { color },
});

export const outlinedPrimaryBtnSx = {
  borderColor: "var(--color-primary)",
  color: "var(--color-primary)",
  textTransform: "none" as const,
  borderRadius: "6px",
  "&:hover": {
    borderColor: "var(--color-primary-dark)",
    backgroundColor: "var(--color-primary-alpha-05)",
  },
};

export const containedPrimaryBtnSx = {
  backgroundColor: "var(--color-primary)",
  textTransform: "none" as const,
  borderRadius: "6px",
  "&:hover": { backgroundColor: "var(--color-primary-dark)" },
};
